import React from 'react';
import { CheckCircle } from 'lucide-react';

const SECTIONS = [
  {
    title: 'Key takeaways & data notices',
    detail: 'Rule-based highlights and warnings when data is incomplete or unusual',
  },
  {
    title: 'Income vs expenses',
    detail: 'Regular vs one-off income, headline and underlying savings rates',
  },
  {
    title: 'Period comparison',
    detail: 'Year-over-year or equal-length prior period when data is reliable',
  },
  {
    title: 'Category spending breakdown',
    detail: 'Expense totals and transaction counts by category',
  },
  {
    title: 'Budget performance',
    detail: 'Monthly limits, utilisation %, status, and period variance',
  },
  {
    title: 'Recommended next steps',
    detail: 'Checklist from triggered rules (no AI required)',
  },
  {
    title: 'Month-over-month trend',
    detail: 'Monthly income, expenses, net, and change vs the previous month',
  },
] as const;

export function FinancialSummaryReportSections(): React.ReactElement {
  return (
    <div className="mt-4 rounded-lg border border-gray-200 bg-white p-4">
      <h4 className="text-sm font-semibold text-gray-900">Included in this export</h4>
      <ul className="mt-3 space-y-2">
        {SECTIONS.map((section) => (
          <li key={section.title} className="flex gap-2 text-sm text-gray-700">
            <CheckCircle className="mt-0.5 h-4 w-4 shrink-0 text-green-500" aria-hidden />
            <span>
              <span className="font-medium text-gray-900">{section.title}</span>
              <span className="text-gray-600"> — {section.detail}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
